import axios from "axios";
import Swal from "sweetalert2";
import { getInstance } from "./baseapi";
const dataToken = localStorage.getItem("tokenBackoffice");
const URL = process.env.REACT_APP_BASE_URL;
const instace = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});
const instanceGetData = getInstance();
export const getAdmin = async (query = {}) => {
  try {
    const headers = {
      Authorization: "Bearer " + dataToken,
    };
    const response = await instanceGetData.get(`/api/user`, {
      headers: headers,
      params: query,
    });
    if (response.status === 200) {
      return response;
    } else {
      return null;
    }
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: error.response.data.message,
      confirmButtonText: "OK",
    }).then((result) => {});
  }
};
export const getAdminByID = async (id) => {
  try {
    const headers = {
      Authorization: "Bearer " + dataToken,
    };
    const response = await instanceGetData.get(`/api/user/${id}`, {
      headers: headers,
    });

    if (response.status === 200) {
      return await response;
    } else {
      return null;
    }
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: error.response.data.message,
      confirmButtonText: "OK",
    }).then((result) => {});
  }
};
export const updateAdminByID = async (id, body) => {
  try {
    const headers = {
      Authorization: "Bearer " + dataToken,
    };
    const response = await instanceGetData.put(`/api/user/${id}`, body, {
      headers: headers,
    });

    if (response.status === 200) {
      return response;
    } else {
      return null;
    }
  } catch (error) {
    // console.log("errorv  message : ", error.response.data.message);
    // Swal.fire({
    //   icon: "error",
    //   title: error.response.data.message,
    //   confirmButtonText: "OK",
    // }).then((result) => {});
    // return error.response
    throw error
  }
};

export const createAdmin = async (body) => {
  try {
    const headers = {
      Authorization: "Bearer " + dataToken,
    };
    const response = await instanceGetData.post(`/api/user`, body, {
      headers: headers,
    });

    if (response.status === 200) {
      return response;
    } else {
      return null;
    }
  } catch (error) {
    // Swal.fire({
    //   icon: "error",
    //   title: error.response.data.message,
    //   confirmButtonText: "OK",
    // }).then((result) => {});
    throw error
  }
};

export const searchAdmin = async (data) => {
  try {
    const headers = {
      Authorization: "Bearer " + dataToken,
    };
    const response = await instanceGetData.get(`/api/user`, {
      headers: headers,
      params: {
        name: data.name,
        active: data.active,
        permission_id: data.permission_id,
      },
    });

    if (response.status === 200) {
      return response;
    } else {
      return null;
    }
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: error.response.data.message,
      confirmButtonText: "OK",
    }).then((result) => {});
  }
};

export const deleteAdmin = async (id) => {
  try {
    const headers = {
      Authorization: "Bearer " + dataToken,
    };
    const response = await instanceGetData.delete(`/api/user/${id}`, {
      headers: headers,
    });

    if (response.status === 200) {
      return await response;
    } else {
      return null;
    }
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: error.response.data.message,
      confirmButtonText: "OK",
    }).then((result) => {});
  }
};

//  /api/user/profile
export const getProfile = async (token) => {
  try {
    const headers = {
      Authorization: "Bearer " + token ?? dataToken,
    };
    const response = await instanceGetData.get(`/api/user/profile`, {
      headers: headers,
    });
    if (response.status === 200) {
      return response;
    } else {
      return null;
    }
  } catch (error) {
    console.log(`reload`);
    throw error;
    // Swal.fire({
    //   icon: "error",
    //   title: "อยู่ระหว่างการตรวจสอบข้อมูล",
    //   confirmButtonText: "ตกลง",
    // }).then((result) => {});
    // window.location.reload();
  }
};